import * as Apollo from '@apollo/client';
import { useState } from 'react';

export interface UsePaginatedQueryResult {
  page: number;
  rowsPerPage: number;
  setPage: (page: number) => void;
  setRowsPerPage: (rowsPerPage: number) => void;
}

export function usePaginatedQuery<
  T,
  BaseVars extends Record<string, unknown>,
  V extends BaseVars & { limit?: number | null; offset?: number | null },
>(
  useQueryHook: (options: Apollo.SuspenseQueryHookOptions<T, V>) => Apollo.UseSuspenseQueryResult<T, V>,
  options?: Apollo.SuspenseQueryHookOptions<T, V> & { initialRowsPerPage?: number },
): Apollo.UseSuspenseQueryResult<T, V> & UsePaginatedQueryResult {
  /* the state can easily be moved to url params through nuqs */
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(options?.initialRowsPerPage ?? 25);

  const hookResult = useQueryHook({
    variables: {
      ...options?.variables,
      limit: rowsPerPage,
      offset: page * rowsPerPage,
    } as unknown as V,
    ...options,
  });

  return {
    ...hookResult,
    page,
    rowsPerPage,
    setPage,
    setRowsPerPage,
  };
}
